// 缓存策略(读/写): 内存 > cookie / localStorage
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cookie = require('../cookie');

var _cookie2 = _interopRequireDefault(_cookie);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var COOKIE = 'cookie';
var STORAGE = 'storage';
var GEOTYPEKEY = 'geoType';

var Cache = function () {
    function Cache() {
        _classCallCheck(this, Cache);

        this.type = 'cache';
        this.cacheDuration = 15 * 60 * 1000;
        this.isSupportLS = this.supportLocalStorage();
        this.positionMemory = {};
    }

    _createClass(Cache, [{
        key: 'initData',
        value: function initData() {
            this.cacheType = _config2.default.get('cacheType');
            this.disabled = !!~_config2.default.get('disables').indexOf('cache');
            this.storageKey = _config2.default.get('storageName');
            this.cookieKey = _config2.default.get('cookieNames');
            this.isSupportCity = _config2.default.get('city');
        }
    }, {
        key: 'process',
        value: function process(succ, fail, next) {
            var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            // 预处理
            typeof succ == 'function' || (succ = this.noop);
            typeof fail == 'function' || (fail = this.noop);
            typeof next == 'function' || (next = this.noop);

            // API禁用逻辑在外层，此处不做冗余判断
            // 数据初始化
            this.initData();

            // 组件：默认使用内存
            var result = this.getFromMemory();
            if (result) return succ(_extends(result, { type: this.type }), opt.token);

            // 业务：指定缓存类型
            if (this.cacheType == COOKIE) {
                result = this.getFromCookie();
            } else if (this.cacheType == STORAGE) {
                result = this.getFromStorage();
            } else {
                return next(); // 不匹配
            }
            if (result) return succ(_extends(result, { type: this.type }), opt.token);
            fail({
                code: 412, // 未命中
                type: this.type
            }, opt.token);
        }
    }, {
        key: 'syncProcess',
        value: function syncProcess() {
            this.initData();
            if (this.disabled) return;
            if (this.cacheType === COOKIE) {
                return this.getFromCookie();
            } else if (this.cacheType === STORAGE) {
                return this.getFromStorage();
            }
        }
    }, {
        key: 'store',
        value: function store() {
            var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            // 数据初始化
            this.cacheType === undefined && this.initData();
            if (this.disabled) return;

            // 默认使用内存
            _extends(this.positionMemory, position);
            this.positionMemory.startTime = this.positionMemory.startTime || Date.now(); // 设置过期时间

            // 来自Cache的数据不再存储
            if (position.type == this.type) return;

            // 校验
            if (!this.validate(position)) return;

            if (this.cacheType === COOKIE) {
                this.storeCookie(position);
            } else if (this.cacheType === STORAGE) {
                this.storeLocalStorage(position);
            }
        }
    }, {
        key: 'getFromMemory',
        value: function getFromMemory() {
            // 校验
            if (new Date() - (this.positionMemory.startTime || new Date()) < this.cacheDuration && this.validate(this.positionMemory)) {
                return this.positionMemory;
            }
            return false;
        }
    }, {
        key: 'getFromStorage',
        value: function getFromStorage() {
            if (!this.isSupportLS) return false;
            var ret = localStorage.getItem(this.storageKey);
            if (!ret) return false;
            try {
                ret = JSON.parse(ret);
                typeof ret.city == 'string' && (ret.city = JSON.parse(ret.city));
                if (new Date() - (ret.startTime || new Date()) < this.cacheDuration && this.validate(ret)) {
                    return ret;
                }
                localStorage.removeItem(this.storageKey);
                return false;
            } catch (e) {
                return false;
            }
        }
    }, {
        key: 'getFromCookie',
        value: function getFromCookie() {
            if (Object.prototype.toString.call(this.cookieKey) !== '[object Array]') return false;
            var ret = {
                lat: (0, _cookie2.default)(this.cookieKey[0]),
                lng: (0, _cookie2.default)(this.cookieKey[1]),
                geoType: (0, _cookie2.default)(GEOTYPEKEY) // 说明
            };
            if (!this.validate(ret)) return false;
            var backup = this.isSupportCity && this.getFromStorage();
            if (backup && backup.lat == ret.lat && backup.lng == ret.lng) {
                return backup;
            } else {
                return ret;
            }
        }
    }, {
        key: 'validate',
        value: function validate() {
            var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (parseFloat(position.lat) && parseFloat(position.lng)) {
                return true;
            }
            return false;
        }
    }, {
        key: 'storeCookie',
        value: function storeCookie() {
            var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            position = _extends({}, position); // FIXME: 引用参数
            if (Object.prototype.toString.call(this.cookieKey) !== '[object Array]') return;

            var setting = {
                expires: this.cacheDuration / 1000 / 3600 / 24,
                path: '/',
                domain: this.getCookieDomain()
            };
            (0, _cookie2.default)(this.cookieKey[0], position.lat, setting);
            (0, _cookie2.default)(this.cookieKey[1], position.lng, setting);
            (0, _cookie2.default)(GEOTYPEKEY, position.geoType, setting);

            if (this.isSupportCity && position.city) {
                /**
                 * cookie不直接存储city信息 -> 1.非通用 2.数据重
                 * 暂时用localStorage存储, key一致 -> 两种方式是互斥的, 不冲突
                 */
                position.city = JSON.stringify(position.city); // FIXME: 嵌套对象单独处理, 线上转义: 未知原因(xss?)
                this.isSupportLS && localStorage.setItem(this.storageKey, JSON.stringify(position)); // 不再设置过期时间
            }
        }
    }, {
        key: 'storeLocalStorage',
        value: function storeLocalStorage() {
            var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (!this.isSupportLS) return;

            var ret = _extends({}, position);
            ret.startTime = +new Date();
            localStorage.setItem(this.storageKey, JSON.stringify(ret));
        }
    }, {
        key: 'supportLocalStorage',
        value: function supportLocalStorage() {
            // iphone safari 无痕模式下设置localStorage时候会抛异常
            var testKey = 'local_test';
            try {
                localStorage.setItem(testKey, 1);
                localStorage.removeItem(testKey);
            } catch (e) {
                return false;
            }
            return true;
        }
    }, {
        key: 'getCookieDomain',
        value: function getCookieDomain() {
            // TODO: .meituan.com .meituan.net域名
            var hostname = location.hostname;
            if (/.*\.51ping\.com$/.test(hostname)) {
                return '.51ping.com';
            } else if (/.*\.dianping\.com$/.test(hostname)) {
                return '.dianping.com';
            } else {
                return hostname;
            }
        }
    }, {
        key: 'noop',
        value: function noop() {}
    }]);

    return Cache;
}();

var instance = new Cache();

module.exports = instance.process.bind(instance);
module.exports.set = instance.store.bind(instance);
module.exports.syncAPI = instance.syncProcess.bind(instance);
module.exports.type = instance.type;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/whereami/lib/geos/cache.js
// module id = 355
// module chunks = 0